import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {ClientContactForm} from '../../shop/clients/components/ClientContactForm'
import {TextInput} from '../../../../components/inputs/TextInput'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {ModeleClientContact, modeleClientContactInitValues} from '../../../../components/Models'
import {createClientContact} from '../../../../components/requests'
import {useNavigate} from 'react-router-dom'

const clientContactSchema = Yup.object().shape({
  nom: Yup.string().required('Le nom est requis'),
  prenom: Yup.string().required('Le prénom est requis'),
  telephone: Yup.string()
    .notRequired()
    .matches(
      /^(?:\+33|33|0)[\s.-]*[1-9](?:[\s.-]?\d{2}){4}$/,
      'Format du numéro de téléphone invalide'
    ),
  mobile: Yup.string()
    .notRequired()
    .matches(/^(?:\+33|33|0)[\s.-]*[1-9](?:[\s.-]?\d{2}){4}$/, 'Format du mobile invalide'),
  email: Yup.string()
    .notRequired()
    .when(['telephone', 'mobile'], {
      is: (telephone, mobile) =>
        (!telephone || telephone.length < 1) && (!mobile || mobile.length < 1),
      then: () =>
        Yup.string()
          .required('Veuillez renseigner au moins un contact (fixe, mobile ou email)')
          .email("L'adresse mail n'est pas valide"),
      otherwise: () => Yup.string().notRequired(),
    }),
  posteOccupe: Yup.string().notRequired(),
})

const AddContactModal = (props) => {
  const {
    clientId,
    setDefaultValueContact,
    setIsFromClientContact,
    setObjetCommunication,
    setContactedBy,
    dataContact,
  } = props
  let initialData = {}

  const obj: ModeleClientContact = {
    id: null,
    nom: '',
    prenom: '',
    telephone: '',
    mobile: '',
    email: '',
    posteOccupe: '',
    principal: false,
  }
  initialData = {...obj}

  const [data, setData] = useState<ModeleClientContact>(initialData)
  const [loading, setLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const navigate = useNavigate()
  const toggleModalRef = useRef<any>()

  useEffect(() => {
    if (dataContact !== null) { // pour le cas du modification (les champs sont pré-rempli)
      setIsEdit(true)
      formik.setFieldValue('nom', dataContact?.nom)
      formik.setFieldValue('id', dataContact?.id)
      formik.setFieldValue('prenom', dataContact?.prenom)
      formik.setFieldValue('telephone', dataContact?.telephone)
      formik.setFieldValue('mobile', dataContact?.mobile)
      formik.setFieldValue('email', dataContact?.email)
      formik.setFieldValue('posteOccupe', dataContact?.posteOccupe)
      formik.setFieldValue('principal', dataContact?.principal)
    }else{
      setIsEdit(false)
      formik.setFieldValue('nom', '')
      formik.setFieldValue('id', null)
      formik.setFieldValue('prenom', '')
      formik.setFieldValue('telephone', '')
      formik.setFieldValue('mobile', '')
      formik.setFieldValue('email', '')
      formik.setFieldValue('posteOccupe', '')
      formik.setFieldValue('principal', false)
    }
  }, [dataContact])

  const submitForm = async (
    fieldsToUpdate: Partial<ModeleClientContact>,
    callback
  ): Promise<void> => {
    const updatedData = Object.assign({...modeleClientContactInitValues}, fieldsToUpdate)
    var requestOk = false
    try {
      const clientContactRequest = await createClientContact(clientId, updatedData)
      if (clientContactRequest?.status === 200) {
        if (
          clientContactRequest?.data?.id !== undefined &&
          clientContactRequest?.data?.id !== null
        ) {
          requestOk = true
          const transformedData = clientContactRequest
            ? {
                value: clientContactRequest?.data?.id,
                label: clientContactRequest?.data?.email,
              }
            : null
          // setDefaultValueContact(transformedData)
          setDefaultValueContact(clientContactRequest?.data?.id)
          setIsFromClientContact(true)
          setObjetCommunication({
            email: clientContactRequest?.data?.email ?? '',
            mobile: clientContactRequest?.data?.mobile ?? '',
            telephone: clientContactRequest?.data?.telephone ?? '',
          })
          setContactedBy(clientContactRequest?.data)
          if (toggleModalRef.current) {
            toggleModalRef.current.click()
          }
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
    }
  }

  const formik = useFormik<ModeleClientContact>({
    initialValues: data,
    validationSchema: clientContactSchema,
    onSubmit: (values) => {
      setLoading(true)
      setTimeout(() => {
        const updatedData = Object.assign({...data}, values)

        submitForm(updatedData, (response) => {
          formik.resetForm()
          setLoading(false)
        })
      }, 200)
    },
  })

  return (
    <div className='modal fade' tabIndex={-1} id='add_contact'>
      <div className='modal-dialog modal-lg'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>{isEdit ? 'Modification' : 'Création'} du contact</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Nom complet</label>

                <div className='col-lg-8'>
                  <div className='row'>
                    <div className='col-lg-6 fv-row'>
                      <TextInput
                        fieldName={'nom'}
                        inputPlaceholder={'Nom'}
                        inputType={'text'}
                        inputClassName={
                          'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        }
                        formik={formik}
                      />
                    </div>

                    <div className='col-lg-6 fv-row'>
                      <TextInput
                        fieldName={'prenom'}
                        inputPlaceholder={'Prénom'}
                        inputType={'text'}
                        inputClassName={
                          'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        }
                        formik={formik}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>Téléphone</label>

                <div className='col-lg-8'>
                  <div className='row'>
                    <div className='col-lg-6 fv-row'>
                      <TextInput
                        fieldName={'telephone'}
                        inputPlaceholder={'Fixe'}
                        inputType={'text'}
                        inputClassName={
                          'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        }
                        formik={formik}
                      />
                    </div>

                    <div className='col-lg-6 fv-row'>
                      <TextInput
                        fieldName={'mobile'}
                        inputPlaceholder={'Mobile'}
                        inputType={'text'}
                        inputClassName={
                          'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        }
                        formik={formik}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>Email</label>

                <div className='col-lg-8 fv-row'>
                  <TextInput
                    fieldName={'email'}
                    inputPlaceholder={'Email'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>Poste occupé</label>

                <div className='col-lg-8 fv-row'>
                  <TextInput
                    fieldName={'posteOccupe'}
                    inputPlaceholder={'Poste occupé'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-lg-12'>
                  <label className='form-check form-check-inline form-check-solid me-5'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value={1}
                      name={'principal'}
                      checked={formik.values?.principal}
                      onChange={(e) => {
                        formik.setFieldValue('principal', e.target.checked)
                      }}
                    />
                    <span className='fw-bold ps-2 fs-6'>Contact principal</span>
                  </label>
                </div>
              </div>
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light'
                data-bs-target='#choixContactModal'
                data-bs-toggle='modal'
                data-bs-dismiss='modal'
              >
                Retour
              </button>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && 'Enregistrer'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Enregistrement...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
                <span
                  data-bs-target='#choixContactModal'
                  data-bs-toggle='modal'
                  data-bs-dismiss='modal'
                  ref={toggleModalRef}
                ></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddContactModal
